import React, { Component } from 'react';
import './Account.css';

import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import { withAuthorization, withStorageSync } from '../../session/index';
import * as ROUTES from '../../constants/routes';

import { updateUser, getUserByUid } from '../../firebase/api/users';
import {
    doEmailUpdate,
    doPasswordUpdate,
    reauthenticate,
    doSignOut,
} from '../../firebase/api/auth';
import { convertDateToFirestoreTimestamp } from '../../firebase/api/firestoreUtils';

import { getAuthUser } from '../../static/localStorage';

import AccountDetails from '../../components/account/AccountDetails';
import AccountSecurity from '../../components/account/AccountSecurity';
import { ConfirmationModal } from '../../components/elements/modal/ConfirmModal';
import ConfirmPassword from '../../components/elements/customModals/ConfirmPassword/ConfirmPassword';
import CloseAccount from '../../components/account/CloseAccount';

const INITIAL_STATE = {
    categories: [],
    displayChangeDetailsConfirmationDialog: false,
    displaySendResetPasswordDialog: false,
    displayUpdatePasswordInfoDialog: false,
    confirmationPassword: null,
    displayChangePasswordBody: false,
    accountSecurityDTO: {
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
        error: null,
    },
    accountDetailsDTO: getAuthUser(),
};

class AccountSettings extends Component {
    constructor(props) {
        super(props);
        this.state = { ...INITIAL_STATE };
    }

    componentDidMount() {
        const accountDetailsDTO = { ...this.state.accountDetailsDTO };
        getUserByUid(accountDetailsDTO.uid).then(user => {
            this.setState({ accountDetailsDTO: { ...accountDetailsDTO, ...user } });
        });
    }

    onTextInputChange = event => {
        const accountDetailsDTO = { ...this.state.accountDetailsDTO };
        accountDetailsDTO[event.target.name] = event.target.value;
        this.setState({ accountDetailsDTO });
    };

    onBirthdayChange = value => {
        const accountDetailsDTO = { ...this.state.accountDetailsDTO };
        accountDetailsDTO.birthdayTimestamp = convertDateToFirestoreTimestamp(new Date(value));
        this.setState({ accountDetailsDTO });
    };

    reuthenticateAndUpdateUserDetails = () => {
        const accountDetailsDTO = { ...this.state.accountDetailsDTO };
        const confirmationPassword = this.state.confirmationPassword;
        reauthenticate(confirmationPassword).then(() => {
            doEmailUpdate(accountDetailsDTO.email).then(() => {
                updateUser(accountDetailsDTO).then(() => {
                    this.props.history.push(ROUTES.POSTS);
                });
            });
        });
    };

    onPasswordChange = event => {
        const accountSecurityDTO = { ...this.state.accountSecurityDTO };
        accountSecurityDTO[event.target.name] = event.target.value;
        this.setState({ accountSecurityDTO });
    };

    onNewPasswordSubmit = () => {
        //TODO: add validation for current, new, confirm passwords
        this.reuthenticateAndUpdatePassword();
    };

    reuthenticateAndUpdatePassword = () => {
        const accountSecurityDTO = { ...this.state.accountSecurityDTO };

        reauthenticate(accountSecurityDTO.currentPassword)
            .then(() => {
                doPasswordUpdate(accountSecurityDTO.newPassword).then(() => {
                    this.setState({ displayUpdatePasswordInfoDialog: true });
                });
            })
            .catch(error => {
                accountSecurityDTO.error = error.message;
                this.setState({ accountSecurityDTO });
            });
    };

    resetPassword = () => {
        //TODO: send a reset email
        console.log('resetPassword');
        doSignOut();
    };

    render() {
        const {
            accountDetailsDTO,
            accountSecurityDTO,
            displayChangeDetailsConfirmationDialog,
            displayChangePasswordBody,
            displaySendResetPasswordDialog,
            displayUpdatePasswordInfoDialog,
        } = this.state;
        return (
            <div id="account" className="container-fluid">
                {/*<div className='information'>*/}
                {/*    <h1>Your Validate Profile</h1>*/}
                {/*    <p>If you need to update your details you can edit them below.</p>*/}
                {/*</div>*/}
                <div className="account-details">
                    <AccountDetails
                        dto={accountDetailsDTO}
                        onTextInputChange={this.onTextInputChange}
                        displayBody={displayChangePasswordBody}
                        onBirthdayChange={this.onBirthdayChange}
                        onSubmit={() =>
                            this.setState({ displayChangeDetailsConfirmationDialog: true })
                        }
                    />
                    {displayChangeDetailsConfirmationDialog && (
                        <ConfirmPassword
                            modal={displayChangeDetailsConfirmationDialog}
                            toggle={() =>
                                this.setState(prevState => ({
                                    displayChangeDetailsConfirmationDialog: !prevState.displayChangeDetailsConfirmationDialog,
                                }))
                            }
                            onConfirm={this.reuthenticateAndUpdateUserDetails}
                            onInputChange={e =>
                                this.setState({ confirmationPassword: e.target.value })
                            }
                        />
                    )}
                    <AccountSecurity
                        dto={accountSecurityDTO}
                        onPasswordChange={this.onPasswordChange}
                        onChangePasswordClick={() =>
                            this.setState(prevState => ({
                                displayChangePasswordBody: !prevState.displayChangePasswordBody,
                            }))
                        }
                        onPasswordSubmit={this.onNewPasswordSubmit}
                        displayBody={displayChangePasswordBody}
                        error={accountSecurityDTO.error}
                        onResetPasswordClick={() =>
                            this.setState({ displaySendResetPasswordDialog: true })
                        }
                    />
                    {displaySendResetPasswordDialog && (
                        <ConfirmationModal
                            headerTitle="Password resetting"
                            bodyText={`Send an email to ${accountDetailsDTO.email} with a link to reset a password`}
                            onConfirm={this.resetPassword}
                            confirmButtonText="Send"
                            onCancel={() =>
                                this.setState({ displaySendResetPasswordDialog: false })
                            }
                            cancelButtonText="Cancel"
                        />
                    )}
                    {displayUpdatePasswordInfoDialog && (
                        <ConfirmationModal
                            headerTitle="New password"
                            bodyText={`${accountDetailsDTO.firstName} your new password: ${accountSecurityDTO.newPassword}`}
                            onConfirm={() =>
                                this.setState({ displayUpdatePasswordInfoDialog: false })
                            }
                            confirmButtonText="Continue"
                        />
                    )}
                </div>
            </div>
        );
    }
}

const condition = authUser => !!authUser;

export default compose(withAuthorization(condition), withRouter, withStorageSync)(AccountSettings);
